// "use strict";//js严格模式

import Vue from 'vue';
import axios from "axios";
import router from '../router/index.js'
import baseurl from '../assets/js/baseurl';
axios.defaults.baseURL = baseurl;
/* 0测试、1生产 */
// let baseUrl = 0;

// let jft, fy, captain, allap;
// if (baseUrl == 0) {//测试环境
//     /*ajax配置*/
//     // axios.defaults.baseURL = 'http://localhost:28086'; // 本地-亚楠
//     axios.defaults.baseURL = 'https://hr-api-test.xyjhr.cn'; // 测试环境
//     // axios.defaults.baseURL = 'http://192.168.31.29:28086'; // 测试环境
    

// } else if (baseUrl == 1) { //生产环境
//     /*ajax配置*/
//     //  axios.defaults.baseURL = 'http://47.92.115.39:18086/'; //本地 - 孙
//      axios.defaults.baseURL = 'https://hr-api.xyjhr.cn'; //康 测试
// }

axios.defaults.headers.common["token"] = localStorage.getItem("token"); // 设置请求头为 Authorization

localStorage.setItem("headersAppTag", "");//全部

axios.defaults.timeout = 300000; // 5分钟
//axios拦截器，目的是为了在请求头上带上token
axios.interceptors.request.use(
    config => {
        // 拦截的数据
        let token = localStorage.getItem("token");
        if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.token = `${token}`;
        }
        return config;
    },
    err => {
        return config
    });
// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    // 响应的数据
    if (response.data.code == '401') {
        layer.open({
            content: "登录超时，请重新登录",
            skin: "msg",
            time: 2
        });
        router.push('/')
        localStorage.clear()
        console.log(2, '401')
    } else {
        return response;
    }
}, function (error) {
    // 对响应错误做点什么
    if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
        // 请求超时
        if (window.layer) {
            layer.open({
                content: "请求超时，请检查网络或稍后重试",
                skin: "msg",
                time: 3
            });
        } else {
            alert("请求超时，请检查网络或稍后重试");
        }
    } else if (error.response) {
        // 服务器返回了错误状态码
        const status = error.response.status;
        let message = "请求失败，请稍后重试";
        
        switch (status) {
            case 400:
                message = "请求参数错误";
                break;
            case 403:
                message = "没有权限访问";
                break;
            case 404:
                message = "请求的资源不存在";
                break;
            case 500:
                message = "服务器错误，请稍后重试";
                break;
            case 502:
                message = "网关错误";
                break;
            case 503:
                message = "服务暂时不可用";
                break;
        }
        
        if (window.layer) {
            layer.open({
                content: message,
                skin: "msg",
                time: 3
            });
        }
    } else if (error.request) {
        // 请求已发出但没有收到响应（网络错误）
        if (window.layer) {
            layer.open({
                content: "网络连接失败，请检查网络",
                skin: "msg",
                time: 3
            });
        }
    }
    
    return Promise.reject(error);
});

Vue.prototype.axios = axios;



// WEBPACK FOOTER //
// ./src/plugins/axios.js